import { render, staticRenderFns } from "./StepProperties.vue?vue&type=template&id=73e4bab4&scoped=true"
import script from "./StepProperties.vue?vue&type=script&lang=js"
export * from "./StepProperties.vue?vue&type=script&lang=js"
import style0 from "./StepProperties.vue?vue&type=style&index=0&id=73e4bab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e4bab4",
  null
  
)

export default component.exports